var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6663 1.8916V5.33372C11.6663 5.80043 11.6663 6.03378 11.7572 6.21204C11.8371 6.36885 11.9645 6.49633 12.1213 6.57622C12.2996 6.66705 12.533 6.66705 12.9997 6.66705H16.4418M13.333 10.8337H6.66634M13.333 14.167H6.66634M8.33301 7.50033H6.66634M11.6663 1.66699H7.33301C5.93288 1.66699 5.23281 1.66699 4.69803 1.93948C4.22763 2.17916 3.84517 2.56161 3.60549 3.03202C3.33301 3.5668 3.33301 4.26686 3.33301 5.66699V14.3337C3.33301 15.7338 3.33301 16.4339 3.60549 16.9686C3.84517 17.439 4.22763 17.8215 4.69803 18.0612C5.23281 18.3337 5.93288 18.3337 7.33301 18.3337H12.6663C14.0665 18.3337 14.7665 18.3337 15.3013 18.0612C15.7717 17.8215 16.1542 17.439 16.3939 16.9686C16.6663 16.4339 16.6663 15.7338 16.6663 14.3337V6.66699L11.6663 1.66699Z",
    stroke: "#F37721",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconOrange);
export default __webpack_public_path__ + "static/media/file-icon-orange.2c4e3e7bf347fce70fbf5b2b061a3bab.svg";
export { ForwardRef as ReactComponent };